import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { DateTime } from 'luxon';
import { LUXON_DATUM_FORMATS } from './ecertnl-date.model';

export const CUSTOM_DATE_FORMATS = {
  parse: {
    dateInput: 'DD-MM-YYYY',
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD-MM-YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Injectable()
export class CustomAppDateAdapter extends NativeDateAdapter {
  useUtcForDisplay = true;

  format(date: Date, displayFormat: string): string {
    if (displayFormat === 'DD-MM-YYYY') {
      return DateTime.fromJSDate(date).toFormat(LUXON_DATUM_FORMATS.VERKORT);
    } else {
      return DateTime.fromJSDate(date).toFormat(LUXON_DATUM_FORMATS.UITGESCHREVEN, { locale: 'nl' });
    }
  }

  parse(value: number | string): Date | null {
    if (typeof value == 'number') {
      return new Date(value);
    } else if (typeof value === 'string' && (value.match(/-/g) || []).length == 2) {
      const str = value.split('-');
      const year = Number(str[2]);
      const month = Number(str[1]) - 1;
      const date = Number(str[0]);

      return this.validateDate(year, month, date);
    } else {
      return null;
    }
  }

  validateDate(year: number, month: number, date: number): Date | null {
    if (year >= 0 && year < 100) {
      year += 2000;
    }

    const testDate: Date = new Date(year, month, date, 0, 0, 0, 0);

    if (testDate.getDate() != date || testDate.getMonth() != month || testDate.getFullYear() != year) {
      return null;
    } else {
      return testDate;
    }
  }

  getFirstDayOfWeek(): number {
    return 1;
  }
}
